import { render, staticRenderFns } from "./ButtonShowFiles.vue?vue&type=template&id=19886d33&"
import script from "./ButtonShowFiles.vue?vue&type=script&lang=ts&"
export * from "./ButtonShowFiles.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports